module.exports = __webpack_public_path__ + "img/heima.d7c85e05.png";